import React from "react";
import "./BoardButton.scss";

const BoardButton = ({
  children,
  variant = "secondary",
  size = "md",
  icon,
  block = false,
  className = "",
  type = "button",
  disabled = false,
  onClick,
  ...rest
}) => {
  const classes = [
    "pb-btn",
    `pb-btn--${variant}`,
    size === "sm" ? "pb-btn--sm" : "",
    block ? "pb-btn--block" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {icon && <span className="pb-btn__icon" aria-hidden="true">{icon}</span>}
      {children}
    </button>
  );
};

export default BoardButton;
